import { useEffect, useState } from 'react';
import { Card, Empty, ErrorBanner } from '../components/Layout.jsx';
import { apiFetch } from '../store.js';

export default function PromptVersions() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [picked, setPicked] = useState([]);   // up to 2 version strings

  useEffect(() => {
    let cancelled = false;
    apiFetch('/dashboard/prompt-versions')
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(e); });
    return () => { cancelled = true; };
  }, []);

  function toggle(v) {
    setPicked((prev) => {
      if (prev.includes(v)) return prev.filter((x) => x !== v);
      const next = [...prev, v];
      return next.slice(-2); // keep last two
    });
  }

  const versions = data?.versions || [];

  return (
    <>
      <ErrorBanner error={error} />
      <Card title="Prompt versions">
        {versions.length === 0 ? <Empty>No analyses recorded yet.</Empty> : (
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Version</th>
                <th>Uses</th>
                <th>Last used</th>
              </tr>
            </thead>
            <tbody>
              {versions.map((v) => (
                <tr key={v.version}>
                  <td>
                    <input
                      type="checkbox"
                      checked={picked.includes(v.version)}
                      onChange={() => toggle(v.version)}
                    />
                  </td>
                  <td><code>{v.version}</code></td>
                  <td>{v.uses}</td>
                  <td>{v.last_used_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>

      {picked.length === 2 && (
        <Card title={`Compare: ${picked[0]} vs ${picked[1]}`}>
          <p style={{ color: 'var(--text-secondary)' }}>
            Side-by-side diff requires the desktop client (which holds the
            actual prompt text). This view shows usage counts only — pick two
            versions and open the Prompt Inspector in Brand Voice Studio to
            diff the prompt bodies.
          </p>
        </Card>
      )}
    </>
  );
}
